import { ReactNode } from "react"
import { Flex, Text } from "@shared/primitive-components"
import * as styles from "./detailListStyles"

type Props = Readonly<{
  title: string
  bold?: boolean
  children: ReactNode | ReactNode[]
  color?: "red" | "green"
}>

const Item = ({ title, children, bold = false, color }: Props) => (
  <Flex as="li" css={styles.item(color)}>
    <Text css={styles.makeTextStyle(bold, true)}>{title}</Text>
    <Text css={styles.makeTextStyle(bold)}>{children}</Text>
  </Flex>
)

Item.displayName = `DetailList.Item`

Item.defaultProps = {
  bold: false,
  children: undefined,
}

export { Item }
